"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.releoxTranslations = void 0;
const deepmerge_1 = __importDefault(require("deepmerge"));
const DataTable_translation_1 = __importDefault(require("./components/DataTable/DataTable.translation"));
const AsyncSelect_translation_1 = __importDefault(require("./components/form/AsyncSelect/AsyncSelect.translation"));
const GenericForm_translation_1 = __importDefault(require("./generic-scenes/GenericForm/GenericForm.translation"));
const _GenericFormScene_translation_1 = __importDefault(require("./generic-scenes/GenericFormScene/_GenericFormScene.translation"));
const _GenericIndexScene_translation_1 = __importDefault(require("./generic-scenes/_GenericIndexScene/_GenericIndexScene.translation"));
const validate_model_translation_1 = __importDefault(require("./HOC/validate-model/validate-model.translation"));
const AcceptInvitationScene_translation_1 = __importDefault(require("./scenes/AcceptInvitationScene/AcceptInvitationScene.translation"));
const AcceptInvitationSuccessScene_translation_1 = __importDefault(require("./scenes/AcceptInvitationSuccessScene/AcceptInvitationSuccessScene.translation"));
const AuthErrorScene_translation_1 = __importDefault(require("./scenes/AuthErrorScene/AuthErrorScene.translation"));
const ConfirmScene_translation_1 = __importDefault(require("./scenes/ConfirmScene/ConfirmScene.translation"));
const ForgotScene_translation_1 = __importDefault(require("./scenes/ForgotScene/ForgotScene.translation"));
const ForgotSuccessScene_translation_1 = __importDefault(require("./scenes/ForgotSuccessScene/ForgotSuccessScene.translation"));
const LoginScene_translation_1 = __importDefault(require("./scenes/LoginScene/LoginScene.translation"));
const ResetPasswordScene_translation_1 = __importDefault(require("./scenes/ResetPasswordScene/ResetPasswordScene.translation"));
const ResetPasswordSuccessScene_translation_1 = __importDefault(require("./scenes/ResetPasswordSuccessScene/ResetPasswordSuccessScene.translation"));
exports.releoxTranslations = deepmerge_1.default.all([
    AcceptInvitationSuccessScene_translation_1.default,
    AcceptInvitationScene_translation_1.default,
    AsyncSelect_translation_1.default,
    AuthErrorScene_translation_1.default,
    DataTable_translation_1.default,
    ConfirmScene_translation_1.default,
    ForgotScene_translation_1.default,
    ForgotSuccessScene_translation_1.default,
    _GenericIndexScene_translation_1.default,
    _GenericFormScene_translation_1.default,
    LoginScene_translation_1.default,
    ResetPasswordScene_translation_1.default,
    ResetPasswordSuccessScene_translation_1.default,
    validate_model_translation_1.default,
    GenericForm_translation_1.default,
]);
//# sourceMappingURL=releox-translations.js.map